import React, { useState, useEffect, useRef } from 'react';
import { Widget } from '@digital/ui';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsMore from "highcharts/highcharts-more";
import HC_exporting from 'highcharts/modules/exporting'
import { GraficoRpp } from '@app/api/tabelaProjetoOverView';
HighchartsMore(Highcharts);
HC_exporting(Highcharts)

interface GraficoProjectsOverviewProps {
    graficoRpp: GraficoRpp,
    tituloGrafico: string,
}

const GraficoProjectsOverview = ({ graficoRpp, tituloGrafico }: GraficoProjectsOverviewProps) => {

    const chartRef = useRef(null);

    const removerSimboloNegativo = (valor: string) => {
        return valor.replace('-', '');
    }

    const chartOptions = {
        chart: {
            type: 'waterfall'
        },

        title: {
            text: `${tituloGrafico}`
        },

        xAxis: {
            type: 'category',
        },

        yAxis: {
            title: {
                text: 'BRL'
            }
        },

        legend: {
            enabled: false,
        },

        plotOptions: {
            series: {
                lineWidth: 0
            }
        },


        tooltip: {
            pointFormat: '<b> R$ {point.y:,.2f} </b> BRL'
        },

        series: [{
            data: [{
                name: 'Bud.',
                y: graficoRpp.capEx,
                color: '#08340D',
            },
            {
                name: 'Cont.',
                dataLabels: {
                    enabled: false
                },
                y: graficoRpp.contHidden,
                visible: false
            },
            {
                name: 'Cont.',
                isSum: true,
                color: '#006129'
            },
            {
                name: 'Exec.',
                dataLabels: {
                    enabled: false
                },
                y: graficoRpp.execuHidden,
                visible: false
            },
            {
                name: 'Exec.',
                isIntermediateSum: true,
                color: '#80BDA6'
            },
            {
                name: 'Reques.',
                visible: false,
                dataLabels: {
                    enabled: false
                },
                y: graficoRpp.reqsHidden
            },
            {
                name: 'Reques.',
                y: graficoRpp.reqs,
                color: '#E1865C'
            },
            {
                name: 'To Cont.',
                y: graficoRpp.toCont,
                color: '#FFA357'
            },
            {
                name: 'For.',
                isSum: true,
                color: '#8C0400',
            },
            {
                name: 'Bal.',
                y: graficoRpp.balance,
                color: '#FFA357'
            }],
            dataLabels: {
                enabled: true,
                formatter: function () {
                    return removerSimboloNegativo(this.y.toLocaleString('pt-br', { minimumFractionDigits: 1 }))
                },
                verticalAlign: 'top'
            },
            pointPadding: 0
        }]
    };



    return (
        <Widget
            title=""
            span={12}
            actions={[]}
        >
            <HighchartsReact
                ref={chartRef}
                highcharts={Highcharts}
                options={chartOptions}
            />
        </Widget >
    );
}


export default GraficoProjectsOverview;
